module.exports = __webpack_public_path__ + "static/Fellix-Regular-954eb0b98fd89e49f3dbc41ce643c931.woff2";